import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import api from "@/api";
import { LogoMark } from "@/components/Logo";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminDashboard from "@/components/admin/AdminDashboard";

export default function AdminPage() {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null));
  }, []);

  return (
    <div className="min-h-screen bg-brand-slate" data-testid="admin-page">
      <header className="border-b border-white/10 bg-brand-teal/60 backdrop-blur">
        <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-5 sm:px-8">
          <span className="flex items-center gap-3">
            <LogoMark className="h-6" />
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-brand-ice">
              Area Riservata
            </span>
          </span>
          <Link
            to="/"
            data-testid="admin-back-home"
            className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-white/70 transition hover:text-brand-ice"
          >
            <ArrowLeft className="h-3.5 w-3.5" />
            Torna al sito
          </Link>
        </div>
      </header>

      {user === undefined ? (
        <div className="flex min-h-[70vh] items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-brand-cyan" />
        </div>
      ) : !user ? (
        <AdminLogin onSuccess={setUser} />
      ) : (
        <AdminDashboard user={user} onLogout={() => setUser(null)} />
      )}
    </div>
  );
}
